import { SHOW_FOOTER, HIDE_FOOTER } from 'actions/footer';

export default (state = { showFooter: false }, action) => {
    switch (action.type) {
        case SHOW_FOOTER:
            return {showFooter: true}

        case HIDE_FOOTER:
            return {showFooter: false}
    }

    return state;
}